import React from 'react';

// Utility function to detect video source type
const getVideoSourceType = (url) => {
  if (!url) return null;

  // YouTube URL detection
  if (url.includes('youtube.com/watch?v=') ||
    url.includes('youtu.be/') ||
    url.includes('youtube.com/shorts/') ||
    url.includes('www.youtube.com/shorts/')) {
    return 'youtube';
  }

  // Vimeo URL detection
  if (url.includes('vimeo.com/')) {
    return 'vimeo';
  }

  // Direct video file detection (mp4, webm, ogg)
  const videoExtensions = ['.mp4', '.webm', '.ogg'];
  if (videoExtensions.some(ext => url.toLowerCase().endsWith(ext))) {
    return 'direct';
  }

  return 'other';
};

// Flexible Video Player Component
const VideoPlayer = ({ selectedVideo, autoPlay = false, controls = true }) => {
  if (!selectedVideo || !selectedVideo.videoUrl) {
    return <div className="text-center text-gray-500">No video selected</div>;
  }

  const sourceType = getVideoSourceType(selectedVideo.videoUrl);

  switch (sourceType) {
    case 'youtube':
      let youtubeId = null;
      // Extract YouTube video ID
      if (selectedVideo.videoUrl.includes('watch?v=')) {
        youtubeId = selectedVideo.videoUrl.split('v=')[1]?.split('&')[0];
      } else if (selectedVideo.videoUrl.includes('youtu.be/')) {
        youtubeId = selectedVideo.videoUrl.split('youtu.be/')[1]?.split('?')[0];
      } else if (selectedVideo.videoUrl.includes('/shorts/')) {
        youtubeId = selectedVideo.videoUrl.split('/shorts/')[1]?.split('?')[0];
      }
      console.log('youtubeId', youtubeId)
      return (
        <iframe
          src={`https://www.youtube.com/embed/${youtubeId}${autoPlay ? '?autoplay=1' : ''}`}
          title="YouTube Video Player"
          className="w-full h-full rounded-lg"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      );

    case 'vimeo':
      // Extract Vimeo video ID
      const vimeoId = selectedVideo.videoUrl.split('vimeo.com/')[1]?.split('?')[0];
      return (
        <iframe
          src={`https://player.vimeo.com/video/${vimeoId}${autoPlay ? '?autoplay=1' : ''}`}
          title="Vimeo Video Player"
          className="w-full h-full rounded-lg"
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
        />
      );

    case 'direct':
    case 'other':
    default:
      return (
        <video
          src={selectedVideo.videoUrl}
          controls={controls}
          className="w-full h-full rounded-lg"
          autoPlay={autoPlay}
        >
          Your browser does not support the video tag.
        </video>
      );
  }
};

export default VideoPlayer;